module.exports = __webpack_public_path__ + "images/emoji/kimono.ce91d5ae6f376a6a6a36.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kimono.png
// module id = 65Wr
// module chunks = 1